import { Component, OnDestroy, OnInit } from '@angular/core';
import { WaterBody } from 'anchor-shared/lib/model/entity/waterBody';
import { WaterBodyDAO } from '../../../core/services/dao/waterBodyDAO';
import { ActivatedRoute } from '@angular/router';
import { ContainsSubscriptions } from '../../../core/services/interfaces/contains-subscriptions';
import { Subscription } from 'rxjs';
import { unsubscribeFromAll } from '../../../core/pure-functions/rx-helper';

@Component({
  selector: 'app-all-for-hire',
  templateUrl: './all-for-hire.component.html',
  styleUrls: ['./all-for-hire.component.scss'],
})
export class AllForHireComponent
  implements OnInit, OnDestroy, ContainsSubscriptions
{
  subs: Subscription[] = [];
  public waterBody: WaterBody = {} as WaterBody;
  model: any = {};
  waterBodies: WaterBody[];

  constructor(
    private waterBodyDAO: WaterBodyDAO,
    private route: ActivatedRoute,
  ) {
    const paramsSub = route.params.subscribe((params) => {
      const waterSub = this.waterBodyDAO
        .getById(params.waterBodyId)
        .subscribe((wb) => {
          this.waterBody = wb;
        });
      this.subs.push(waterSub);
    });
    this.subs.push(paramsSub);
  }

  ngOnInit() {
    let id = this.route.snapshot.params.waterBodyId;
    const waterSub = this.waterBodyDAO.getById(id).subscribe((wb) => {
      this.waterBody = wb;
    });
    const watersSub = this.waterBodyDAO.get().subscribe((wb) => {
      this.waterBodies = wb;
    });
    this.subs.push(waterSub, watersSub);
  }

  ngOnDestroy(): void {
    unsubscribeFromAll(this.subs);
  }
}
